module.exports = __webpack_public_path__ + "static/thisin-that-e92f6e56c0d0ca6916c69f11b52b6d8f.png";